import { useMemo } from 'react';
import keyBy from 'lodash/keyBy';
import uniq from 'lodash/uniq';
import moment from 'moment';
import { useCreatorbaseTimeSeries, useTiktokAudios } from '@round/creatorbase-helpers/api-hooks';
import { isNumber } from 'utility/utility';
import { useProjectCampaigns } from './useProjectCampaigns';

const today = moment().format('YYYY-MM-DD');
const twoWeeksAgo = moment().subtract(14, 'days').format('YYYY-MM-DD');

export function useProjectTikTokCampaigns() {
    const campaigns = useProjectCampaigns('tiktok');

    const audioIds = useMemo(() => {
        const ids = campaigns.data?.results.map((c) => c.tiktok_details?.audio_id).filter(isNumber) ?? [];
        return uniq(ids).sort((a, b) => a - b);
    }, [campaigns.data?.results]);

    const audios = useTiktokAudios(
        { id: audioIds.join(','), page_size: audioIds.length },
        { enabled: audioIds.length > 0 }
    );

    const audiosById = useMemo(() => keyBy(audios.data?.results ?? [], 'id'), [audios.data?.results]);

    const audioTimeSeries = useCreatorbaseTimeSeries(
        {
            type: 'tiktok_audio',
            fields: ['posts_daily_change'],
            ids: audioIds,
            start_date: twoWeeksAgo,
            end_date: today,
        },
        { enabled: audioIds.length > 0 }
    );

    return {
        ...campaigns,
        audios: {
            data: audiosById,
            isLoading: audios.isLoading,
            isError: audios.isError,
        },
        audioTimeSeries: {
            data: audioTimeSeries.data ?? {},
            isLoading: audioTimeSeries.isLoading,
            isError: audioTimeSeries.isError,
        },
    };
}
